import React, { Component } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { SelectAjTemplate } from 'containers/sections/aj-events'
import { Form } from 'components/layout'
import { Divider, FloatingBar, FormButton } from 'components/misc'
import {
  AJAssessor,
  AJEventAddress,
  AJEventDates,
  AJEventOverview,
  AJGeneralInfo
} from 'components/sections/adventurous-journeys'
import { apiActivities, apiAjEvents, apiAssessors, apiConfiguration, apiLists } from 'helpers/decorators/api'
import { form, permissions } from 'helpers/decorators'
import { validate } from 'models/aj-events'
import { ROLES } from 'constants/enums'
import DetailLoader from 'components/loaders/DetailLoader/DetailLoader'
import { ACTIVITY_CATEGORIES, CONFIGURATION_KEYS } from '../../../../constants/enums'
import { asyncValidate } from '../../../../models/aj-events/validateAssessor'
import { mapSchema } from '../../../../models/aj-events'


const enhance = compose(
  apiAjEvents({
    detail: true,
    updateAjEventDetail: true
  }),
  permissions(),
  apiConfiguration(),
  apiAssessors(),
  apiActivities(),
  apiLists({ transportationMode: true }),
  connect(({ api, auth }) => ({
    eventOrgId: get(api, 'ajEvents.detail.organization.id'),
    userType: auth.organization.userType,
    authOrgId: get(auth, 'organization.id'),
    configuration: api.configuration
  })),
  form({
    form: 'ajEventUpdate',
    initialProps: 'ajEvents.detail',
    initialPropsMapper: mapSchema,
    disableHook: true,
    validate,
    asyncValidate
  })
)

class AjEventDetail extends Component {
  static propTypes = {
    pristine: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    submitFailed: PropTypes.bool,
    invalid: PropTypes.bool,
    ajEvents: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    lists: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    activities: PropTypes.object.isRequired,
    values: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    updateAjEvent: PropTypes.func.isRequired,
    deleteAjEvent: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    onActivityParentChange: PropTypes.func.isRequired,
    userType: PropTypes.string,
    onAjTypeChange: PropTypes.func.isRequired,
    permissions: PropTypes.object.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    onGetAvailableAssessorsForActivityCategory: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired
  }


  async componentDidMount() {
    await this.handleUpdate({}, this.props)
  }


  async componentWillReceiveProps(newProps) {
    await this.handleUpdate(this.props, newProps)
  }

  getOrgId(props) {

    return get(props, 'eventOrgId')
  }

  getSubCategory(props) {
    return get(props, 'values.activityCategory.id')
  }

  getIsAssessorManagementEnabled(props) {
    const valueMap = get(props, 'ajEvents.detail.configuration.valueMap')

    return valueMap && valueMap[CONFIGURATION_KEYS.manageAssessors.id]
  }

  async handleUpdate(props, newProps) {
    const newOrgId = this.getOrgId(newProps)

    const newSubCategory = this.getSubCategory(newProps)

    const newIsAssessorManagementEnabled = this.getIsAssessorManagementEnabled(newProps)

    const orgIdChanged = (newOrgId !== this.getOrgId(props))

    const subCategoryChanged = (newSubCategory !== this.getSubCategory(props))

    const isAssessorManagementEnabledChanged = (newIsAssessorManagementEnabled !== this.getIsAssessorManagementEnabled(props))

    if ((orgIdChanged || subCategoryChanged || isAssessorManagementEnabledChanged)
      && newIsAssessorManagementEnabled && newSubCategory && newSubCategory !== ACTIVITY_CATEGORIES.other.id && newOrgId
    ) {
      await this.props.onGetAvailableAssessorsForActivityCategory(newOrgId, newSubCategory)
    }

  }

  isAssessorChanged = (userType, ajEvents, setupAssessorId, isAssessorManagementEnabled) => {
    if(isAssessorManagementEnabled){
      return (get(ajEvents, 'detail.assessor') && userType === ROLES.LEADER.u) && get(ajEvents, 'detail.assessor.id') !== setupAssessorId
    } else {
      return get(ajEvents, 'detail.assessor') && userType === ROLES.LEADER.u
    }
  }

  render() {
    const {
      ajEvents,
      codeLists,
      common,
      activities,
      values,
      pristine,
      submitSucceeded,
      submitFailed,
      invalid,
      handleSubmit,
      updateAjEvent,
      change,
      onActivityParentChange,
      userType,
      onAjTypeChange,
      initialize,
      lists
    } = this.props

    const isAssessorManagementEnabled = this.getIsAssessorManagementEnabled(this.props)

    const setupAssessorId = get(values, 'setupAssessorId')

    const showReasonForChanging = this.isAssessorChanged(userType, ajEvents, setupAssessorId, isAssessorManagementEnabled)

    const loading = ajEvents.loading

    const subcategoryValue = get(values, 'activityCategory.id')

    const setupSupervisorId = get(values, 'setupSupervisorId')

    const isCreatedByParticipant = get(ajEvents, 'detail.createdByPerson.participant')

    const assessorData = get(ajEvents, 'detail.assessor')

    const supervisorData = get(ajEvents, 'detail.supervisor')

    return (
      <Form
        className="form"
        onSubmit={handleSubmit(updateAjEvent)}
        loading={loading}
        contentLoader={
          <DetailLoader modulesCount={3} withProfilePicture={false} />
        }
        isEvent
      >
        <div className="row">
          <div className="col-xs-6">
            <div className="base-margin-small--bottom">
              <SelectAjTemplate change={change} activities={activities} />
            </div>
            <Divider />
            <AJGeneralInfo
              data={values}
              change={change}
              ajEvent={ajEvents.detail}
              eventTypes={codeLists.ajEventCategories.list}
              activities={activities}
              transportationModeList={lists.transportationMode.list}
              awardLevels={codeLists.awardLevelTypes.list}
              onActivityParentChange={onActivityParentChange}
              onAjTypeChange={onAjTypeChange}
              isCreatedByParticipant={isCreatedByParticipant}
              isAssessorManagementEnabled={isAssessorManagementEnabled}
              initialize={initialize}
            />
          </div>

          <div className="col-xs-6">
            <AJEventOverview
              data={ajEvents}
              modal={this.props.modal}
              onDelete={this.props.deleteAjEvent}
            />
            <AJAssessor
              title="Assessor"
              intlKey="moduleTitle.assessor"
              formPrefix="assessor"
              titles={codeLists.titles.list}
              showReason={showReasonForChanging}
              supervisor={false}
              subcategoryValue={subcategoryValue}
              setupAssessorId={setupAssessorId}
              isAssessorManagementEnabled={isAssessorManagementEnabled}
              isCreatedByParticipant={isCreatedByParticipant}
              data={assessorData}
              ajEvents={ajEvents}
              initialize={initialize}
              change={change}
            />
          </div>
          <div className="col-xs-6">
            <AJAssessor
              title="Supervisor"
              intlKey="moduleTitle.supervisor"
              disabledIntlKey="label.supervisor_disabled_for_other_activity"
              disabledDefault="Supervisor selection is disabled for other activity."
              formPrefix="supervisor"
              titles={codeLists.titles.list}
              supervisor={true}
              subcategoryValue={subcategoryValue}
              setupSupervisorId={setupSupervisorId}
              isAssessorManagementEnabled={isAssessorManagementEnabled}
              isCreatedByParticipant={isCreatedByParticipant}
              data={supervisorData}
              ajEvents={ajEvents}
              initialize={initialize}
              change={change}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6">
            <div className="base-margin--bottom">
              <AJEventDates values={values} />
            </div>
          </div>
        </div>

        <AJEventAddress
          change={change}
          countries={common.countries.list}
          data={ajEvents.detail}
        />

        <FloatingBar>
          <FormButton
            pristine={pristine}
            submitSucceeded={submitSucceeded}
            submitFailed={submitFailed}
            invalid={invalid}
            type="submit"
          >
            <FormattedMessage id="label.save" defaultMessage="Save" />
          </FormButton>
        </FloatingBar>
      </Form>
    )
  }
}

export default enhance(AjEventDetail)
